import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import AppRoutes from './routes/AppRoutes';
import { ROUTER_BASENAME } from './config/routerBasename';

function App() {
  return (
    <AuthProvider>
      <Router basename={ROUTER_BASENAME}>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}

export default App;
